import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

//importing modules

import app from './modules/app';
import auth from './modules/auth';
import screening from './modules/screening';
import consumer from './modules/consumer';

Vue.use (Vuex);

export default new Vuex.Store ({
  state: {},
  actions: {
    resetAll({commit}) {
      commit ('app/reset');
      commit ('auth/reset');
      commit ('screening/reset');
      commit ('consumer/reset');
    },
  },
  modules: {
    app,
    auth,
    screening,
    consumer,
  },
  plugins: [
    createPersistedState ({
      key: 'il-film-screening',
      /**
       * FIXME: the plugin doesn't have option of excluding paths
       * so need to include all the modules which we need to be persist
       * NEED to find a way to do it programmatically to add the module
       */
      paths: ['screening', 'consumer'],
    })
  ],
});
